import React, { useState } from 'react';

import { Wrapper, Status } from '@googlemaps/react-wrapper';
import CSS from 'csstype';

import GoogleMap from './GoogleMap';
import Marker from './Marker';

interface MapComponentProps {
  coordinates?: { lat: number; lng: number };
  zoomInit?: number;
  style?: CSS.Properties;
}

const MapComponent: React.FC<MapComponentProps> = ({ coordinates, zoomInit = 8, style = { height: '100%' } }) => {
  const [zoom, setZoom] = useState(zoomInit);
  const [center, setCenter] = useState<google.maps.LatLngLiteral>(coordinates || { lat: 43.296398, lng: 5.37 });
  const render = (status: Status) => {
    return <h1>{status}</h1>;
  };

  return (
    <Wrapper apiKey={import.meta.env.VITE_GOOGLE_API_KEY || ''} render={render}>
      <GoogleMap center={center} zoom={zoom} style={style}>
        {coordinates && <Marker position={center} />}
      </GoogleMap>
    </Wrapper>
  );
};

export default MapComponent;
